"use client"

import { BedDouble } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BedDoubleIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BedDoubleIcon = component(Icon)({ as: BedDouble })
